import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ChevronLeft, Home } from 'lucide-react';
import { OposaiLogo } from '@/components/TuPlazaIALogo';
import UserCreditsPanel from '@/components/UserCreditsPanel';

const CreditsPage = ({ user }) => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-indigo-50">
      {/* Header */}
      <nav className="border-b border-slate-200 bg-white/70 backdrop-blur-xl sticky top-0 z-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between h-16 items-center">
            <div className="flex items-center gap-4">
              <button onClick={() => navigate(-1)} className="p-2 rounded-lg hover:bg-slate-100">
                <ChevronLeft className="w-5 h-5 text-slate-600" />
              </button>
              <OposaiLogo size={36} />
            </div>
            <Button variant="outline" onClick={() => navigate('/dashboard')}>
              <Home className="w-4 h-4 mr-2" />
              Volver al Dashboard
            </Button>
          </div>
        </div>
      </nav>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <h1 className="text-3xl font-bold text-slate-800 mb-2">Mis Créditos</h1>
        <p className="text-slate-600 mb-8">Gestiona tus créditos y compra más cuando los necesites</p>
        
        <UserCreditsPanel user={user} />
      </div>
    </div>
  );
};

export default CreditsPage;
